module.exports = __webpack_public_path__ + "img/logo@2x.16abe7c0.png";